import React from 'react';
import PageHeader from '../components/PageHeader';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Contact = () => {
  return (
    <div className="w-full bg-brand-light min-h-screen pb-24">
      <PageHeader 
        title="Contact Us" 
        description="Reach out for consulting, private training, scheduled courses, or general inquiries." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10 relative z-20">
        <div className="grid lg:grid-cols-12 gap-0 bg-white rounded-3xl shadow-xl overflow-hidden border border-slate-200">
          
          {/* Info Side */}
          <div className="lg:col-span-5 bg-brand-navy text-white p-10 lg:p-12 flex flex-col justify-between">
            <div className="mb-12">
              <h2 className="text-3xl font-extrabold mb-4">Get in Touch</h2>
              <p className="text-slate-300 font-medium">We respond to all inquiries within 24 business hours.</p>
            </div>
            
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center shrink-0">
                  <SafeIcon icon={FiIcons.FiPhone} className="text-brand-green text-xl" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-300 mb-1">Phone</h3>
                  <a href="tel:+12602227827" className="text-lg font-bold hover:text-brand-green transition-colors">+1 260 222 7827</a>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center shrink-0">
                  <SafeIcon icon={FiIcons.FiMail} className="text-brand-green text-xl" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-300 mb-1">Email</h3>
                  <a href="mailto:info@boesandboes.com" className="text-lg font-bold hover:text-brand-green transition-colors">info@boesandboes.com</a>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center shrink-0">
                  <SafeIcon icon={FiIcons.FiMapPin} className="text-brand-green text-xl" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-300 mb-1">Location</h3>
                  <p className="text-lg font-bold">Fort Wayne, Indiana</p>
                  <p className="text-sm text-slate-400 mt-1 font-medium">Local, National & International Service</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Form Side */}
          <div className="lg:col-span-7 p-10 lg:p-16">
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-2">Full Name</label>
                  <input type="text" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium" />
                </div>
                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-2">Email Address</label>
                  <input type="email" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium" />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-2">Inquiry Options</label>
                <div className="relative">
                  <select className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all appearance-none font-medium">
                    <option>Consulting</option>
                    <option>Private Training</option>
                    <option>Scheduled Courses</option>
                    <option>Leadership Development</option>
                    <option>Exercises</option>
                    <option>General Questions</option>
                  </select>
                  <SafeIcon icon={FiIcons.FiChevronDown} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-500 pointer-events-none" />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-bold text-slate-700 mb-2">Message</label>
                <textarea rows="5" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all resize-none font-medium"></textarea>
              </div>
              
              <button type="submit" className="w-full sm:w-auto px-10 py-4 bg-brand-green text-white font-bold rounded-xl hover:bg-green-600 transition-colors shadow-lg shadow-brand-green/20">
                Send Message
              </button>
            </form>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Contact;